import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __accessCheck = function __accessCheck(obj, member, msg) {
  if (!member.has(obj)) throw TypeError("Cannot " + msg);
};

var __privateGet = function __privateGet(obj, member, getter) {
  __accessCheck(obj, member, "read from private field");

  return getter ? getter.call(obj) : member.get(obj);
};

var __privateAdd = function __privateAdd(obj, member, value) {
  if (member.has(obj)) throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};

var __privateSet = function __privateSet(obj, member, value, setter) {
  __accessCheck(obj, member, "write to private field");

  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};

var __privateMethod = function __privateMethod(obj, member, method) {
  __accessCheck(obj, member, "access private method");

  return method;
};

var _prevState, _render, render_fn, _onChange, onChange_fn;

import { MediaChromeListbox, createOption, createIndicator } from "./media-chrome-listbox.js";
import "./media-chrome-option.js";
import { globalThis, document } from "../utils/server-safe-globals.js";
import { MediaUIAttributes, MediaUIEvents } from "../constants.js";
import { parseTextTracksStr, stringifyTextTrackList, formatTextTrackObj, toggleSubsCaps } from "../utils/captions.js";
var ccIcon = "\n<svg aria-hidden=\"true\" viewBox=\"0 0 26 24\" part=\"captions-indicator indicator\">\n  <path d=\"M22.83 5.68a2.58 2.58 0 0 0-2.3-2.5c-3.62-.24-11.44-.24-15.06 0a2.58 2.58 0 0 0-2.3 2.5c-.23 4.21-.23 8.43 0 12.64a2.58 2.58 0 0 0 2.3 2.5c3.62.24 11.44.24 15.06 0a2.58 2.58 0 0 0 2.3-2.5c.23-4.21.23-8.43 0-12.64Zm-11.39 9.45a3.07 3.07 0 0 1-1.91.57 3.06 3.06 0 0 1-2.34-1 3.75 3.75 0 0 1-.92-2.67 3.92 3.92 0 0 1 .92-2.77 3.18 3.18 0 0 1 2.43-1 2.94 2.94 0 0 1 2.13.78c.364.359.62.813.74 1.31l-1.43.35a1.49 1.49 0 0 0-1.51-1.17 1.61 1.61 0 0 0-1.29.58 2.79 2.79 0 0 0-.5 1.89 3 3 0 0 0 .49 1.93 1.61 1.61 0 0 0 1.27.58 1.48 1.48 0 0 0 1-.37 2.1 2.1 0 0 0 .59-1.14l1.4.44a3.23 3.23 0 0 1-1.07 1.69Zm7.22 0a3.07 3.07 0 0 1-1.91.57 3.06 3.06 0 0 1-2.34-1 3.75 3.75 0 0 1-.92-2.67 3.88 3.88 0 0 1 .93-2.77 3.14 3.14 0 0 1 2.42-1 3 3 0 0 1 2.16.82 2.8 2.8 0 0 1 .73 1.31l-1.43.35a1.49 1.49 0 0 0-1.51-1.21 1.61 1.61 0 0 0-1.29.58A2.79 2.79 0 0 0 15 12a3 3 0 0 0 .49 1.93 1.61 1.61 0 0 0 1.27.58 1.44 1.44 0 0 0 1-.37 2.1 2.1 0 0 0 .6-1.15l1.4.44a3.17 3.17 0 0 1-1.1 1.7Z\"/>\n</svg>";
var slotTemplate = document.createElement("template");
slotTemplate.innerHTML = "\n  <slot name=\"captions-indicator\" hidden>".concat(ccIcon, "</slot>\n");

var MediaCaptionsListbox = /*#__PURE__*/function (_MediaChromeListbox) {
  _inherits(MediaCaptionsListbox, _MediaChromeListbox);

  var _super = _createSuper(MediaCaptionsListbox);

  function MediaCaptionsListbox() {
    var _this;

    _classCallCheck(this, MediaCaptionsListbox);

    _this = _super.call(this, {
      slotTemplate: slotTemplate
    });

    __privateAdd(_assertThisInitialized(_this), _render);

    __privateAdd(_assertThisInitialized(_this), _onChange);

    __privateAdd(_assertThisInitialized(_this), _prevState, void 0);

    return _this;
  }

  _createClass(MediaCaptionsListbox, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      _get(_getPrototypeOf(MediaCaptionsListbox.prototype), "attributeChangedCallback", this).call(this, attrName, oldValue, newValue);

      if (attrName === MediaUIAttributes.MEDIA_SUBTITLES_LIST && oldValue !== newValue) {
        __privateMethod(this, _render, render_fn).call(this);
      } else if (attrName === MediaUIAttributes.MEDIA_SUBTITLES_SHOWING && oldValue !== newValue) {
        this.value = newValue;
      } else if (attrName === "aria-multiselectable") {
        this.removeAttribute("aria-multiselectable");
        console.warn("Captions List doesn't currently support multiple selections. You can enable multiple items via the media.textTrack API.");
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(MediaCaptionsListbox.prototype), "connectedCallback", this).call(this);

      this.addEventListener("change", __privateMethod(this, _onChange, onChange_fn));
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _get(_getPrototypeOf(MediaCaptionsListbox.prototype), "disconnectedCallback", this).call(this);

      this.removeEventListener("change", __privateMethod(this, _onChange, onChange_fn));
    }
  }, {
    key: "mediaSubtitlesList",
    get: function get() {
      return getSubtitlesListAttr(this, MediaUIAttributes.MEDIA_SUBTITLES_LIST);
    },
    set: function set(list) {
      setSubtitlesListAttr(this, MediaUIAttributes.MEDIA_SUBTITLES_LIST, list);
    }
  }, {
    key: "mediaSubtitlesShowing",
    get: function get() {
      return getSubtitlesListAttr(this, MediaUIAttributes.MEDIA_SUBTITLES_SHOWING);
    },
    set: function set(list) {
      setSubtitlesListAttr(this, MediaUIAttributes.MEDIA_SUBTITLES_SHOWING, list);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(MediaCaptionsListbox), "observedAttributes", this)), ["aria-multiselectable", MediaUIAttributes.MEDIA_SUBTITLES_LIST, MediaUIAttributes.MEDIA_SUBTITLES_SHOWING]);
    }
  }]);

  return MediaCaptionsListbox;
}(MediaChromeListbox);

_prevState = new WeakMap();
_render = new WeakSet();

render_fn = function render_fn() {
  var _a;

  if (__privateGet(this, _prevState) === JSON.stringify(this.mediaSubtitlesList)) return;

  __privateSet(this, _prevState, JSON.stringify(this.mediaSubtitlesList));

  var container = this.shadowRoot.querySelector("#container");
  container.textContent = "";
  var isOff = !this.value;
  var option = createOption(this.formatOptionText("Off"), "off", isOff);
  option.prepend(createIndicator(this, "select-indicator"));
  container.append(option);
  var subtitlesList = this.mediaSubtitlesList;

  var _iterator = _createForOfIteratorHelper(subtitlesList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var subs = _step.value;
      var option2 = createOption(this.formatOptionText(subs.label, subs), formatTextTrackObj(subs), this.value == formatTextTrackObj(subs));
      option2.prepend(createIndicator(this, "select-indicator"));
      var type = (_a = subs.kind) != null ? _a : "subs";

      if (type === "captions") {
        option2.append(createIndicator(this, "captions-indicator"));
      }

      container.append(option2);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

_onChange = new WeakSet();

onChange_fn = function onChange_fn() {
  toggleSubsCaps(this, false);
  if (!this.value) return;
  var event = new globalThis.CustomEvent(MediaUIEvents.MEDIA_SHOW_SUBTITLES_REQUEST, {
    composed: true,
    bubbles: true,
    detail: this.value
  });
  this.dispatchEvent(event);
};

var getSubtitlesListAttr = function getSubtitlesListAttr(el, attrName) {
  var attrVal = el.getAttribute(attrName);
  return attrVal ? parseTextTracksStr(attrVal) : [];
};

var setSubtitlesListAttr = function setSubtitlesListAttr(el, attrName, list) {
  if (!(list == null ? void 0 : list.length)) {
    el.removeAttribute(attrName);
    return;
  }

  var newValStr = stringifyTextTrackList(list);
  var oldVal = el.getAttribute(attrName);
  if (oldVal === newValStr) return;
  el.setAttribute(attrName, newValStr);
};

if (!globalThis.customElements.get("media-captions-listbox")) {
  globalThis.customElements.define("media-captions-listbox", MediaCaptionsListbox);
}

var media_captions_listbox_default = MediaCaptionsListbox;
export { MediaCaptionsListbox, media_captions_listbox_default as default };